import { CVData } from '../models/cv.models';

export const CV_MOCK: CVData = {
  formacionAcademica: [
    {
      tipoAntecedente: 'Magister',
      grado: 'Magister',
      institucion: 'Universidad de Chile',
      pais: 'Chile',
      anioInicio: '2015',
      anioTermino: '2017',
      fechaInicio: '2015-03-01',
      fechaTermino: '2017-12-01',
      estado: 'finalizado',
    },
  ],
  lineasInvestigacion: [
    {
      linea: 'Analitica avanzada para politicas publicas',
      disciplinaArea: 'Ciencias Sociales',
    },
  ],
  experiencia: [
    {
      cargo: 'Investigador Asociado',
      institucion: 'Centro de Innovacion Aplicada',
      experienciaVigente: 'No',
      funcionesPrincipales: 'Liderar iniciativas de investigacion y transferencia tecnologica.',
      fechaInicio: '2018-03-01',
      fechaTermino: '2022-12-01',
    },
  ],
  publicaciones: [
    {
      tipo: 'Paper',
      titulo: 'Analitica avanzada para politicas publicas',
      estructuraAutores: 'Primer autor',
      revistaEditorial: 'Journal of Applied Research',
      doiEnlace: '',
      anio: '2021',
      fecha: '2021-01-01',
    },
  ],
  proyectos: [
    {
      nombreProyecto: 'Plataforma nacional de ciencia de datos',
      codigoFolio: '',
      rol: 'Co-investigador',
      fuenteFinanciamiento: 'ANID',
      anioInicio: '2020',
      anioTermino: '2023',
      fechaInicio: '2020-01-01',
      fechaTermino: '2023-12-01',
    },
  ],
  distinciones: [
    {
      nombreReconocimiento: 'Premio a la Innovacion Publica',
      institucionOtorga: 'Ministerio de Ciencia',
      enlaceRespaldo: '',
      anio: '2022',
      fecha: '2022-01-01',
      descripcion: '',
    },
  ],
  docencia: [
    {
      curso: 'Metodologia de la investigacion',
      institucion: 'Universidad Tecnologica Metropolitana',
      periodo: '2021-2',
    },
  ],
  idiomas: [
    {
      idioma: 'Ingles',
      nivel: 'Avanzado',
    },
  ],
  adjuntos: [
    {
      tipo: 'cv_pdf',
      nombreArchivo: 'cv-camilo-garcia.pdf',
      sizeKb: 380,
    },
  ],
  ultimoBloque: 'estudios',
};

/** PDI de Camilo Andres Garcia Cisterna. Al confirmar se precargan los 6 acordeones. */
export const CV_AUTOLLENADO_PORTAL_MOCK: CVData = {
  formacionAcademica: [
    {
      tipoAntecedente: 'Pregrado',
      grado: 'Ingenieria Civil',
      institucion: 'Universidad de Chile',
      pais: 'Chile',
      anioInicio: '2009',
      anioTermino: '2014',
      fechaInicio: '2009-03-01',
      fechaTermino: '2014-12-01',
      estado: 'finalizado',
    },
    {
      tipoAntecedente: 'Magister',
      grado: 'Magister',
      institucion: 'Universidad de Chile',
      pais: 'Chile',
      anioInicio: '2015',
      anioTermino: '2017',
      fechaInicio: '2015-03-01',
      fechaTermino: '2017-12-01',
      estado: 'finalizado',
    },
  ],
  lineasInvestigacion: [
    {
      linea: 'Analitica avanzada para politicas publicas',
      disciplinaArea: 'Ciencias Sociales',
    },
    {
      linea: 'Transferencia tecnologica en agencias publicas',
      disciplinaArea: 'Ingenieria y Tecnologia',
    },
  ],
  experiencia: [
    {
      cargo: 'Investigador Asociado',
      institucion: 'Centro de Innovacion Aplicada',
      experienciaVigente: 'No',
      funcionesPrincipales: 'Liderar iniciativas de investigacion y transferencia tecnologica.',
      fechaInicio: '2018-03-01',
      fechaTermino: '2022-12-01',
    },
    {
      cargo: 'Gestor institucional',
      institucion: 'Agencia Nacional de Investigacion y Desarrollo',
      experienciaVigente: 'Si',
      funcionesPrincipales: 'Gestion de iniciativas de la Subdireccion de Investigacion Aplicada.',
      fechaInicio: '2023-01-01',
      fechaTermino: '',
    },
  ],
  publicaciones: [
    {
      tipo: 'Paper',
      titulo: 'Analitica avanzada para politicas publicas',
      estructuraAutores: 'Primer autor',
      revistaEditorial: 'Journal of Applied Research',
      doiEnlace: 'https://doi.org/10.0000/anid.2021.001',
      anio: '2021',
      fecha: '2021-06-01',
    },
    {
      tipo: 'Capitulo',
      titulo: 'Datos abiertos para la toma de decisiones en ANID',
      estructuraAutores: 'Coautor',
      revistaEditorial: 'Editorial Cientifica Austral',
      doiEnlace: '',
      anio: '2023',
      fecha: '2023-03-01',
    },
  ],
  proyectos: [
    {
      nombreProyecto: 'Plataforma nacional de ciencia de datos',
      codigoFolio: 'ANID-2020-014',
      rol: 'Co-investigador',
      fuenteFinanciamiento: 'ANID',
      anioInicio: '2020',
      anioTermino: '2023',
      fechaInicio: '2020-01-01',
      fechaTermino: '2023-12-01',
    },
    {
      nombreProyecto: 'Red de colaboracion para investigacion aplicada',
      codigoFolio: 'FONDEF-2021-008',
      rol: 'Investigador principal',
      fuenteFinanciamiento: 'FONDEF',
      anioInicio: '2021',
      anioTermino: '2025',
      fechaInicio: '2021-03-01',
      fechaTermino: '2025-12-01',
    },
  ],
  distinciones: [
    {
      nombreReconocimiento: 'Premio a la Innovacion Publica',
      institucionOtorga: 'Ministerio de Ciencia',
      enlaceRespaldo: '',
      anio: '2022',
      fecha: '2022-11-01',
      descripcion: 'Reconocimiento a iniciativas de transferencia en el sector publico.',
    },
    {
      nombreReconocimiento: 'Reconocimiento a la trayectoria cientifica',
      institucionOtorga: 'Academia Nacional de Ciencias',
      enlaceRespaldo: '',
      anio: '2024',
      fecha: '2024-08-01',
      descripcion: 'Trayectoria de Camilo Andres Garcia Cisterna en investigacion aplicada.',
    },
  ],
  docencia: [
    {
      curso: 'Metodologia de la investigacion',
      institucion: 'Universidad Tecnologica Metropolitana',
      periodo: '2021-2',
    },
  ],
  idiomas: [
    {
      idioma: 'Ingles',
      nivel: 'Avanzado',
    },
  ],
  adjuntos: [
    {
      tipo: 'cv_pdf',
      nombreArchivo: 'cv-camilo-garcia-pdi.pdf',
      sizeKb: 420,
    },
  ],
  ultimoBloque: 'estudios',
};
